import React from 'react';
import styled from 'styled-components';
import { theme, toRem } from 'design';
import { Icon } from '../Icon';
import { IconTypes } from '../Icon/IconTypes';

interface ButtonSignUpProps {
  icon: IconTypes;
  iconFill?: string;
  label: string;
  onClick: () => void;
  className?: string;
}

const Button = styled.button`
  display: flex;
  flex-flow: row nowrap;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: ${toRem(44)};
  border: ${toRem(1)} solid ${theme.color.neutral[200]};
  border-radius: ${toRem(11)};
  background-color: ${theme.color.white};
  transition: background-color ${theme.transition.button.fast};
  font-family: ${theme.font.family.euclid};
  font-weight: ${theme.color.neutral[900]};
  font-size: ${toRem(13.75)};
  cursor: pointer;

  &:hover {
    background-color: rgba(0, 0, 0, 0.02);
  }
`;

const StyledIcon = styled(Icon)`
  margin-right: ${toRem(11)};
  margin-left: ${toRem(-8)};
`;

const ButtonSignUp: React.FC<ButtonSignUpProps> = ({ icon, iconFill, label, onClick, className, ...rest }) => (
  <Button {...rest} className={className} onClick={onClick}>
    <StyledIcon icon={icon} width={16} height={16} fill={iconFill} />
    {label}
  </Button>
);

export default ButtonSignUp;
